import { render } from "./SidenavGroup.vue?vue&type=template&id=0ab48936&scoped=true"
import script from "./SidenavGroup.vue?vue&type=script&lang=js"
export * from "./SidenavGroup.vue?vue&type=script&lang=js"

import "./SidenavGroup.vue?vue&type=style&index=0&id=0ab48936&scoped=true&lang=css"
import "./SidenavGroup.vue?vue&type=style&index=1&id=0ab48936&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab48936"]])

export default __exports__